import {
  faChevronDown,
  faCircle,
  faHeadset,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card } from "react-bootstrap";
import Button from "../Button";
import classNames from "classnames";
import ChatWidgetConversation from "./ChatWidgetConversation";
import { useChatWidgetContext } from "../../../providers/ChatWidgetProvider";
import ChatWidgetFooter from "./ChatWidgetFooter";

const ChatWidget = () => {
  const { isOpenChat, setIsOpenChat } = useChatWidgetContext();
  return (
    <>
      <div
        className={classNames("container-fluid support-chat", {
          "show-chat": isOpenChat,
        })}
      >
        <Card className="bg-body-emphasis chat">
          <Card.Header className="d-flex flex-between-center px-4 py-3 border-bottom">
            <h5 className="mb-0 d-flex align-items-center gap-2 fw-medium">
              Цифровой чат поддержки
            </h5>
            <Button
              variant="link"
              className="p-0 text-black btn-close-chat text-decoration-none d-flex align-items-center justify-content-center dropdown-caret-none"
              onClick={() => setIsOpenChat(false)}
              style={{
                border: "none",
                width: "12px",
                height: "16px",
                minWidth: "12px",
                boxShadow: "none",
              }}
              title="Закрыть чат"
            >
              <FontAwesomeIcon
                icon={faXmark}
                style={{
                  width: "12px",
                  height: "16px",
                  fontWeight: 900,
                }}
              />
            </Button>
          </Card.Header>
          <Card.Body className="scrollbar p-3">
            <ChatWidgetConversation />
          </Card.Body>
          <Card.Footer className="border-top ps-3 pe-4 py-3">
            <ChatWidgetFooter />
          </Card.Footer>
        </Card>
      </div>
      <Button
        className={classNames(
          "p-0 border border-translucent btn-support-chat",
          {
            "btn-chat-close": isOpenChat,
          },
        )}
        onClick={() => setIsOpenChat(!isOpenChat)}
      >
        <span className="fs-8 fw-normal btn-text text-primary text-nowrap">
          Чат поддержки
        </span>
        <span className="ping-icon-wrapper mt-n4 ms-n6 mt-sm-0 ms-sm-2 position-absolute position-sm-relative">
          <span className="ping-icon-bg" />
          <FontAwesomeIcon icon={faCircle} className="ping-icon" />
        </span>
        <FontAwesomeIcon
          icon={faHeadset}
          className="text-primary fs-8 d-sm-none"
        />
        <FontAwesomeIcon icon={faChevronDown} className="text-primary fs-7" />
      </Button>
    </>
  );
};

export default ChatWidget;
